import { MdHelpOutline, MdPersonAdd, MdSettings } from 'react-icons/md';
import { connect } from 'react-redux';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { Divider } from 'rsuite';
import { RootState } from '../../../@types/RootState';
import { User } from '../../../@types/User';
import { selectorUser } from '../../../lib/selectorUser';
import { resetAccessRule } from '../../../services/AccessRuleService';
import { clearLinkAccessSession } from '../../../utils/linkAccessSession';
import { Tag } from '../../Tag';
import styles from './NavBarUserMenuContent.module.scss';

type ContentProps = {
  handleCloseMenu: () => void;
} & ReturnType<typeof mapStateToProps> &
  RouteComponentProps;

type MenuItem = {
  key: string;
  to: string;
  icon: JSX.Element;
  label: string;
  tag?: {
    skin: 'green';
    size: 'small';
    text: string;
  };
  external?: boolean;
  visible: (user: User) => boolean;
};

const MENU_ITEMS: MenuItem[] = [
  {
    key: 'settings',
    to: '/administrador/pessoas',
    icon: <MdSettings size={16} />,
    label: 'Configurações',
    visible: user => !!user?.usuarioAdministrador,
  },
  {
    key: 'people',
    to: '/administrador/pessoas',
    icon: <MdPersonAdd size={16} />,
    label: 'Pessoas',
    tag: {
      skin: 'green',
      size: 'small',
      text: 'CONVIDAR',
    },
    visible: user => !!user?.usuarioAdministrador,
  },
  {
    key: 'knowledge-base',
    to: 'https://www.infoprice.co/base-de-conhecimento/infopanel/',
    icon: <MdHelpOutline size={16} />,
    label: 'Base de conhecimento',
    external: true,
    visible: () => true,
  },
];

const NavBarUserMenuContent = ({ user, history }: ContentProps) => {
  if (!user) return null;

  const handleSignOut = () => {
    resetAccessRule();
    localStorage.removeItem('autenticacao.token');
    localStorage.removeItem('cliente');
    localStorage.removeItem('usuario');
    clearLinkAccessSession();
    history.push('/login');
    window.location.reload();
  };

  const visibleMenuItems = MENU_ITEMS.filter(item => item.visible(user));

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <span className={styles.name}>{user.usuarioDTO?.fullName}</span>
        <span className={styles.email}>{user.login}</span>
      </div>
      <Divider />
      <div>
        {visibleMenuItems.map(item => (
          <Link key={item.key} to={item.external ? { pathname: item.to } : item.to} target={item.external ? '_blank' : undefined}>
            {item.icon}
            <span>{item.label}</span>
            {item.tag && (
              <Tag skin={item.tag.skin} size={item.tag.size}>
                {item.tag.text}
              </Tag>
            )}
          </Link>
        ))}
      </div>
      <Divider />
      <div>
        <button type="button" onClick={handleSignOut}>
          Sair
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  user: selectorUser(state),
});

export default withRouter(connect(mapStateToProps)(NavBarUserMenuContent));
